import { usePage, Link } from "@inertiajs/react";
import { User } from "@/types/generated";

export const ApplicationBanner = () => {
  const { auth } = usePage<{ auth?: { user: User } }>().props;

  // If no authenticated user, show signup banner
  if (!auth?.user) {
    return (
      <div className="w-full py-2 bg-blue-500 text-white font-ocr sticky top-16 z-10 text-center text-sm md:text-base">
        <Link href="/register" className="underline underline-offset-2">
          Sign up for free to track your lap times and compete with friends!
        </Link>
      </div>
    );
  }

  // If authenticated but no iRacing account, show iRacing connection banner
  if (!auth.user.has_iracing_account) {
    return (
      <div className="w-full py-2 bg-amber-200 font-ocr sticky top-16 z-10 text-center text-sm md:text-base">
        <a href="/auth/iracing" className="underline underline-offset-2">
          Link your iRacing account to automatically import your race data.{" "}
          {` `}
        </a>
      </div>
    );
  }

  return null;
};
